import React from "react";
import { Box, Chip, Alert, Collapse } from "@mui/material";
import { Warning as WarningIcon } from "@mui/icons-material";
import {
  validateEnvironment,
  getEnvironmentInfo,
} from "../utils/environmentValidator";

/**
 * Visual indicator showing current environment
 * Displays warnings if environment configuration is incorrect
 */
const EnvironmentIndicator = () => {
  const validation = validateEnvironment();
  const envInfo = getEnvironmentInfo();
  const [showDetails, setShowDetails] = React.useState(!validation.isValid);

  // Don't show in production if everything is valid
  if (validation.isValid && envInfo.environment === "production") {
    return null;
  }

  const getEnvironmentColor = () => {
    if (!validation.isValid) return "error";
    if (envInfo.environment === "production") return "success";
    if (envInfo.environment === "uat") return "warning";
    return "default";
  };

  const getEnvironmentLabel = () => {
    const env = envInfo.environment.toUpperCase();
    if (!validation.isValid) return `⚠️ ${env} - CONFIG ERROR`;
    return env;
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 16,
        right: 16,
        zIndex: 9999,
      }}
    >
      {/* <Chip
        label={getEnvironmentLabel()}
        color={getEnvironmentColor()}
        size="small"
        icon={!validation.isValid ? <WarningIcon /> : undefined}
        onClick={() => setShowDetails(!showDetails)}
        sx={{
          fontWeight: 600,
          cursor: 'pointer',
          boxShadow: 3,
        }}
      />

      <Collapse in={showDetails}>
        <Alert
          severity={validation.isValid ? 'info' : 'error'}
          onClose={() => setShowDetails(false)}
          sx={{ mt: 1, maxWidth: 350 }}
        >
          <strong>Environment Configuration</strong>
          <Box component="pre" sx={{ fontSize: '0.75rem', mt: 1, mb: 0 }}>
            Environment: {envInfo.environment}
            {'\n'}API URL: {envInfo.baseUrl?.substring(0, 40)}...
          </Box>
          {validation.warnings.length > 0 && (
            <Box sx={{ mt: 1 }}>
              {validation.warnings.map((warning, i) => (
                <Box key={i} sx={{ color: 'error.main', fontSize: '0.875rem' }}>
                  • {warning}
                </Box>
              ))}
            </Box>
          )}
        </Alert>
      </Collapse> */}
    </Box>
  );
};

export default EnvironmentIndicator;
